<div class="language-select-container" [ngClass]="{'small': small() }">
  <div class="language-select-wrapper">
    <mat-icon [inline]="true">language</mat-icon>
    <mat-form-field appearance="fill">
      <mat-select [formControl]="selectControl" panelClass="language-select-panel">
        @for (lang of $langs(); track lang) {
          <mat-option [value]="lang.code">
            {{ lang.localName }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
</div>
